module.exports = __webpack_public_path__ + "static/media/poster8.37d825e7.png";